import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import {getStorage} from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyC9DjPLJ6qksqicCJGXhV1FQLIJ5I9DABI",
  authDomain: "sportscampament.firebaseapp.com",
  projectId: "sportscampament",
  storageBucket: "sportscampament.appspot.com",
  messagingSenderId: "229343909183",
  appId: "1:229343909183:web:552c6fe966a824cd5e6f8a"
};


const app = initializeApp(firebaseConfig);

//authentication
export const auth = getAuth(app);

//Database FIrestore
export const db = getFirestore(app);
// connectFirestoreEmulator(db, 'localhost', 8081);
//Storage
export const storage = getStorage(app);
// connectAuthEmulator(auth, "http://localhost:9099");